export default __webpack_public_path__ + "static/media/dioxido.b7d5a3b9.svg";